import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  CreateLinkedHeatpunkProjectMutation as _CreateLinkedHeatpunkProjectMutation,
  CreateLinkedHeatpunkProjectInput,
} from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const CreateLinkedHeatpunkProjectMutation = graphql(`
  mutation CreateLinkedHeatpunkProject(
    $input: CreateLinkedHeatpunkProjectInput!
  ) {
    createLinkedHeatpunkProject(input: $input) {
      __typename
      ... on CreateLinkedProjectError {
        code
        message
      }
    }
  }
`);

const useCreateLinkedHeatpunkProject = (
  options?: UseMutationOptions<
    _CreateLinkedHeatpunkProjectMutation,
    unknown,
    CreateLinkedHeatpunkProjectInput
  >
) => {
  return useMutation({
    mutationFn: (input: CreateLinkedHeatpunkProjectInput) => {
      return gqlClient.request(CreateLinkedHeatpunkProjectMutation, {
        input,
      });
    },
    ...options,
  });
};

export default useCreateLinkedHeatpunkProject;
